import "./GlobalStyles.scss";

function GlobalStyles({ children }: { children: any }): JSX.Element {
  return <div>{children}</div>;
}

export default GlobalStyles;
